import { render, staticRenderFns } from "./ClientProjectsEditContractors.vue?vue&type=template&id=541c7782&"
import script from "./ClientProjectsEditContractors.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditContractors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports